var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "42px",
    viewBox: "0 0 44 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NEW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    fill: "#F44336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.968,25.232 L23.968,13.168 L20.032,13.168 L20.032,25.232 L23.968,25.232 Z M23.968,33.2 L23.968,29.168 L20.032,29.168 L20.032,33.2 L23.968,33.2 Z M1.71103722,36.1962038 L20.2701465,4.21307657 C20.8245278,3.25770484 22.0484244,2.93263789 23.0037962,3.48701921 C23.3048762,3.66172939 23.5551433,3.91199649 23.7298535,4.21307657 L42.2889628,36.1962038 C42.8433441,37.1515756 42.5182771,38.3754722 41.5629054,38.9298535 C41.2579661,39.1068031 40.9116701,39.2 40.5591092,39.2 L3.44089076,39.2 C2.33632126,39.2 1.44089076,38.3045695 1.44089076,37.2 C1.44089076,36.8474392 1.53408761,36.5011431 1.71103722,36.1962038 Z",
    id: "report_problem---material"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.fe1b4b6405121f5bc53e99d93dc59f56.svg";
export { ForwardRef as ReactComponent };